<template>
  <game-template title="Choisissez l’action la plus appropriée à chacune des étapes d’intégration d’un collaborateur">
    <template v-slot:content>
      <image-quizz :steps="steps"
        @next="next"
        @answer="setAnswer"
        image="arrivee"
        button-label="Commencer"
        last-step-message="Vous avez su faire les bons choix pour gérer l’arrivée d’un collaborateur, ferez-vous un sans-faute pour gérer un départ ?">
      </image-quizz>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import ImageQuizz from '../components/ImageQuizz'

export default {
  name: 'ArrivalGame',
  mixins: [stepMixin],
  components: {
    ImageQuizz
  },
  data () {
    return {
      steps: [
        {
          name: 'step-initial',
          question: 'Vous avez un nouveau mail !',
          goodAnswer: 'a',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je l\'ouvre',
              explanation: '<strong>Bon réflexe !</strong><br/> Que vous soyez sur Workelo ou non, prenez connaissance de l\'email notifiant l\'arrivée de votre nouveau collaborateur. C\'est un processus qui prend du temps et auquel vous devez réfléchir.'
            },
            {
              name: 'b',
              label: 'Je n\'ai pas le temps',
              explanation: 'C\'est peut-être important vous devriez l\'ouvrir.'
            }
          ]
        },
        {
          name: 'step-mail',
          question: 'Bien, Mélodie arrive dans 1 semaine...',
          goodAnswer: 'b',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je crée son planning immédiatement via le simulateur horaire présent en GTA',
              explanation: 'Vous ne trouverez pas le salarié dans l’outil\u00a0: Mélodie sera visible une fois créée en paie (après le 10 du mois). Vous devez préparer son planning en attendant.'
            },
            {
              name: 'b',
              label: 'Je prépare son planning sur Excel et j’attends l\'arrivée réelle de Mélodie avant la création de son planning en GTA',
              explanation: '<strong>Bien vu !</strong><br/> Anticipez sur le planning et affichez-le dans votre dépôt/agence.'
            },
            {
              name: 'c',
              label: 'J’envoie un mail à la RH pour lui demander les étapes pour gérer l’arrivée de Mélodie',
              explanation: 'Votre RH peut vous accompagner lors de l’arrivée de vos premiers collaborateurs mais c\'est à vous de préparer son planning.'
            }
          ]
        },
        {
          name: 'step-excel',
          question: 'Mélodie est arrivée ! Voici son planning temporaire...',
          goodAnswer: 'b',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je prépare son planning sur GTA dans la journée',
              explanation: 'Tant que le nouveau salarié n’est pas créé en paie, ni en GTA, vous ne pourrez pas demander la création du planning.'
            },
            {
              name: 'b',
              label: 'J\'attends sa création en paie pour préparer son planning sur GTA',
              explanation: 'Effectivement, il faut attendre que le collaborateur soit créé en paie pour qu\'il soit visible sur la GTA.'
            }
          ]
        },
        {
          name: 'step-gta-no-plan',
          question: 'Ça y est, Mélodie est visible sur GTA...',
          goodAnswer: 'b',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je crée un planning approchant de la réalité, on verra plus tard pour les ajustements',
              explanation: 'Prenez le temps de faire le point sur les plannings de l’équipe. Si l’arrivée d’un collaborateur modifie le planning d’autres membres de l’équipe, c’est le moment de le faire savoir.'
            },
            {
              name: 'b',
              label: 'Je me connecte au simulateur horaire, je crée un planning type, répondant aux règles du temps de travail et au planning que je vais afficher dans le dépôt/l\'agence',
              explanation: '<strong>Bonne réponse !</strong><br/> En cas de besoin n’hésitez pas à consulter le document relatif aux règles du temps de travail.'
            }
          ]
        },
        {
          name: 'step-gta-plan',
          question: 'Bon, Mélodie est planifiée en GTA...',
          goodAnswer: 'a',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je contrôle le planning créé et note les éventuelles heures excédentaires et absences.',
              explanation: '<strong>Bravo, vous avez bien géré l\'arrivée de Mélodie !</strong><br/> Vous pourrez revenir en GTA à tout moment pour déclarer les éléments.'
            },
            {
              name: 'b',
              label: 'Je n’ai plus rien à faire. C’est quoi la GTA déjà ?',
              explanation: 'Reprenez la procédure depuis le début !'
            }
          ]
        }
      ]
    }
  },
  methods: {
    setAnswer (answer) {
      this.steps.find(step => step.name === answer.step).answer = answer.value
    }
  }
}
</script>

<style lang="scss">

</style>
